var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Neuen Spieler hinzufügen")]),_c('playerCreateVue',{attrs:{"team-id":this.teamId},on:{"canceled":function($event){return _vm.$router.back()},"saved":_vm.saved}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }